"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Renew_1 = __importDefault(require("./Renew"));
class Index {
    constructor(parent, subscriptionId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.subscriptionId = subscriptionId;
    }
    path(withParameter = true) {
        if (withParameter && this.subscriptionId !== null) {
            return `${this.parent.path()}/subscriptions/${this.subscriptionId}`;
        }
        return `${this.parent.path()}/subscriptions`;
    }
    /**
     * Returns a list of webinar subscriptions created by the user for the current authorized client application.
     * HTTP Method: get
     * Endpoint: /webinar/notifications/v1/subscriptions
     * Rate Limit Group: Light
     */
    async list(restRequestConfig) {
        const r = await this.rc.get(this.path(false), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Creates a new webinar subscription for the current authorized user / client application.
     * HTTP Method: post
     * Endpoint: /webinar/notifications/v1/subscriptions
     * Rate Limit Group: Medium
     */
    async post(createWebhookSubscriptionRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createWebhookSubscriptionRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns the webinar subscription by ID
     * HTTP Method: get
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}
     * Rate Limit Group: Light
     */
    async get(restRequestConfig) {
        if (this.subscriptionId === null) {
            throw new Error('subscriptionId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the existing subscription. The client application can extend/narrow
   * the list of events for which it receives notifications within this subscription.
   * If event filters are specified, calling this method modifies them for the
   * existing subscription. The method also allows to set the subscription expiration time.
   * If other than `events` and `expiresIn` parameters are passed in the request they will be ignored.
   * If the request body is empty then the specified subscription will be just renewed without any
   * event filter modifications and with default expiration time.
   *
     * HTTP Method: put
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}
     * Rate Limit Group: Medium
     */
    async put(updateSubscriptionRequest, restRequestConfig) {
        if (this.subscriptionId === null) {
            throw new Error('subscriptionId must be specified.');
        }
        const r = await this.rc.put(this.path(), updateSubscriptionRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Cancels the existing webinar subscription.
     * HTTP Method: delete
     * Endpoint: /webinar/notifications/v1/subscriptions/{subscriptionId}
     * Rate Limit Group: Medium
     */
    async delete(restRequestConfig) {
        if (this.subscriptionId === null) {
            throw new Error('subscriptionId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    renew() {
        return new Renew_1.default(this);
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map